import { getMovementsData } from '@/common/integrations/menhir/employee/movements/movements.service';
import {
  IGetMovementsDataEnvelope,
  IGetMovementsParams,
} from '@/common/integrations/menhir/employee/movements/movements.types';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';

export function useGetMovementsData(
  params: IGetMovementsParams,
  options?: UseQueryOptions<IGetMovementsDataEnvelope>
) {
  const { data, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.MOVEMENTS, JSON.stringify(params)],
    queryFn: () => getMovementsData(params),
    ...options,
  });
  return {
    movements: data?.movements,
    pendingOrders: data?.pendingOrders,
    ...rest,
  };
}
